// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "43f7c9d8",
    "hash": "43f7c9d8",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "43f7c9d8",
    "semverString": null,
    "version": "2026.10.0.14"
};
/* tslint:enable */
